/**
 * Newsletter Service
 */

DM.Service.Newsletter = (function () {
    const ENDPOINT = '/annoy/subscribetopromotions';

    const createFormData = function (data) {
        const formData = new FormData();
        for (const key in data) {
            formData.append(key, data[key]);
        }
        return formData;
    };

    return {
        enrollToNewsletter: function (data) {
            return fetch(ENDPOINT, {
                method: 'POST',
                body: createFormData(data)
            }).then(response => response.json());
        },
    };
})();

